/**
 *  @class
 *  @function upsellProduct
 */
if (!customElements.get('upsell-product')) {
	class upsellProduct extends HTMLElement {
		constructor() {
			super();
			this.button = this.querySelector('.upsell-product__add-btn');
			this.btnText = this.querySelector('.upsell-product__btn-text');
			this.optionInputs = this.querySelectorAll('.upsell-product__options input[type="radio"]');
			this.optionName = this.querySelector('.upsell-product__option-name');
			this.priceEl = this.querySelector('.upsell-product__price');
			this.imageEl = this.querySelector('.upsell-product__image img');
			this.defaultImage = this.imageEl?.src;
			this.cartQuantities = {};
		}
    
		connectedCallback() {
			this.button?.addEventListener('click', this.handleAddToCart.bind(this));

			this.optionInputs.forEach((input) => {
				input.addEventListener('change', this.handleOptionChange.bind(this));
			});

			this.fetchCartAndUpdate();
		}

		async fetchCartAndUpdate() {
			try {
				const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
				const cart = await res.json();

				this.cartQuantities = {};
				cart.items.forEach((item) => {
					this.cartQuantities[item.variant_id] = (this.cartQuantities[item.variant_id] || 0) + item.quantity;
				});
			} catch (e) {
				this.cartQuantities = {};
			}

			this.updateAvailability();
		}

		getSelectedInput() {
			return this.querySelector('.upsell-product__options input[type="radio"]:checked');
		}

		isVariantSoldOut(input) {
			if (!input) return false;

			const management = input.dataset.variantInventoryManagement;
			// If inventory isn't tracked, it's never sold out based on cart
			if (!management || management === 'null' || management === '') return false;

			const available = input.dataset.variantAvailable === 'true';
			if (!available) return true;

			const inventory = parseInt(input.dataset.variantInventory, 10);
			const variantId = parseInt(input.dataset.variantId, 10);
			const inCart = this.cartQuantities[variantId] || 0;

			return inCart >= inventory;
		}

		updateAvailability() {
			const selected = this.getSelectedInput();

			// Update option sold-out states
			this.optionInputs.forEach((input) => {
				const label = input.nextElementSibling;
				if (this.isVariantSoldOut(input)) {
					label?.classList.add('is-sold-out');
				} else {
					label?.classList.remove('is-sold-out');
				}
			});

			// Update button for currently selected variant
			this.updateButtonState(selected);
		}

		updateButtonState(input) {
			if (!input) return;

			const soldOut = this.isVariantSoldOut(input);

			if (soldOut) {
				this.button.disabled = true;
				this.button.classList.remove('is-added');
				this.btnText.textContent = 'Sold Out';
			} else {
				this.button.disabled = false;
				this.button.classList.remove('is-added');
				this.btnText.textContent = 'Add to Cart';
			}
		}

		handleOptionChange(e) {
			const input = e.currentTarget;

			if (this.optionName) {
				this.optionName.textContent = input.value;
			}

			const variantId = input.dataset.variantId;
			if (variantId) {
				this.button.dataset.variantId = variantId;
			}

			const variantPrice = input.dataset.variantPrice;
			if (variantPrice && this.priceEl) {
				this.priceEl.textContent = variantPrice;
			}

			if (this.imageEl) {
				this.imageEl.src = input.dataset.variantImage || this.defaultImage;
			}

			this.updateButtonState(input);
		}

		async handleAddToCart() {
			const variantId = this.button.dataset.variantId;
			if (!variantId || this.button.disabled) return;

			this.button.classList.remove('is-added');
			this.button.classList.add('is-loading');
			this.button.disabled = true;

			try {
				const response = await fetch(`${window.theme?.routes?.cart_add_url || '/cart/add'}.js`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						id: parseInt(variantId, 10),
						quantity: 1,
						properties: {
							'_gift_wrapping': 'yes'
						}
					})
				});

				if (!response.ok) throw new Error('Add to cart failed');

				this.button.classList.remove('is-loading');
				this.button.classList.add('is-added');

				// Re-fetch cart to update quantities and sold-out states
				await this.fetchCartAndUpdate();

				this.updateHeaderCart();

			} catch (err) {
				console.error('Upsell add to cart error:', err);
				this.button.classList.remove('is-loading');
				this.button.disabled = false;
				this.btnText.textContent = 'Add to Cart';
			}
		}

		async updateHeaderCart() {
			try {
				const countEls = document.querySelectorAll('#cart-drawer-toggle .thb-item-count');
				countEls.forEach((el) => {
					const total = Object.values(this.cartQuantities).reduce((sum, q) => sum + q, 0);
					el.textContent = total;
				});

				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
					bubbles: true
				}));
			} catch (e) {
				// Non-critical
			}
		}
	}
	customElements.define('upsell-product', upsellProduct);
}
